import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { connect, ReactReduxContext } from "react-redux";
import { Formik, Form, Field, ErrorMessage, withFormik } from "formik";
import * as yup from "yup";
import { MdSearch, MdLocationOn } from "react-icons/md"; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from "react-bootstrap";
import Heading from "../heading/Heading";
import { Loading } from "../state"; // Global Element

import { FormInput } from "./elements"; // Validation schema

import { validation } from "./util/validation";
import InlineError from "../state/InlineError"; //ga tracker

import gaTracker from "../../util/ga-analytics/gaTracker";
import MediaQuery from "react-responsive";
import { locationDuck } from "../../ducks/location";
var locationOperations = locationDuck.operations;
var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      zipCode: props.zipCode
    };
  },
  validationSchema: yup.object().shape({
    zipCode: validation.cityStateZip
  }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;

    if (typeof props.submitHandler !== "function") {
      return false;
    }

    props.submitHandler(values);

    if (props.closeModal) {
      props.closeModal();
    }
  },
  displayName: "ChangeLocation" // helps with React DevTools

});

var ChangeLocationForm = function ChangeLocationForm(props) {
  var _navigator, _navigator$permission, _ref2, _ref3;

  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      store = props.store,
      err = props.err,
      changeHandler = props.changeHandler,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      hasLocationAccess = _useState2[0],
      sethasLocationAccess = _useState2[1];

  var permissionStatus = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$permission = _navigator.permissions) === null || _navigator$permission === void 0 ? void 0 : _navigator$permission.query({
    name: 'geolocation'
  }).then(function (x) {
    var hasPermission = (x === null || x === void 0 ? void 0 : x.state) !== 'denied';
    sethasLocationAccess(hasPermission);
  }).catch(function (error) {
    console.log(error.message);
    sethasLocationAccess(false);
  }); // const [time, setTime] = useState(Date.now());
  // useEffect(() => {
  //   const interval = setInterval(() => setTime(Date.now()), 5000);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  var useMyLocation = function useMyLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        props === null || props === void 0 ? void 0 : props.getLocation(pos.coords.latitude, pos.coords.longitude);

        if (typeof (props === null || props === void 0 ? void 0 : props.setStore) === 'function') {
          props === null || props === void 0 ? void 0 : props.setStore();
        }
      }, function (err) {
        return console.log(err, 'User nav not got due to an error');
      }, {
        timeout: 5000
      });
    }
  };

  var changeLocationClick = function changeLocationClick() {
    var value;

    try {
      value = document.querySelector("#cb-collapse-locations input[name=zipCode]").value;
    } catch (e) {}

    var data = {
      gtm: {
        uniqueEventId: "33",
        elementTarget: value,
        elementId: "change-location-ChangeLocationForm"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var useLocationButton = function useLocationButton() {
    return /*#__PURE__*/React.createElement(Button, {
      style: {
        border: "unset",
        backgroundColor: "unset",
        paddingLeft: "25px",
        color: "#5F5950",
        marginBottom: "-10px"
      },
      className: "cb-location-modal__use-my-location-button",
      onClick: useMyLocation
    }, /*#__PURE__*/React.createElement(MdLocationOn, {
      className: "cb-location-banner__icon ml-1",
      style: {
        color: "#9F2234"
      }
    }), /*#__PURE__*/React.createElement("label", {
      style: {
        cursor: "pointer",
        color: "#5F5950 !important",
        textDecoration: "underline"
      },
      className: "cb-location-modal__use-my-location-label"
    }, " ", "Use My Location"));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InlineError, {
    store: store,
    error: err
  }), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "5",
    md: "5",
    className: "pr-0 cb-location-modal__input-container"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "zipCode",
    label: "City, State or Zip Code",
    component: FormInput,
    className: "cb-form__input--full cb-location-modal__input",
    changeHandler: changeHandler
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "1",
    md: "1",
    style: {
      padding: "0px"
    },
    className: "cb-location-modal__search-button-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: changeLocationClick,
    className: "cb-location-modal__search-button",
    style: (_ref2 = {
      width: "100%"
    }, _defineProperty(_ref2, "width", "55px"), _defineProperty(_ref2, "backgroundColor", "#9d2235"), _defineProperty(_ref2, "borderRadius", "3px"), _defineProperty(_ref2, "border", "0px solid"), _defineProperty(_ref2, "marginLeft", "-10px"), _ref2)
  }, /*#__PURE__*/React.createElement(MdSearch, {
    onClick: changeLocationClick,
    disabled: isLoading,
    className: "",
    style: {
      color: "white",
      height: "3em"
    }
  }, " "))), /*#__PURE__*/React.createElement(Col, {
    lg: "6",
    md: "6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "cb-banner__title cb-location-modal__or-label",
    style: {
      fontFamily: "Thirsty_Script",
      color: "#653024"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "or")), useLocationButton())), /*#__PURE__*/React.createElement(Col, null)), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "7",
    style: {
      width: "80%"
    },
    className: "pr-0 cb-location-modal__input-container"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "zipCode",
    label: "City, State or Zip Code",
    component: FormInput,
    className: "cb-form__input--full cb-location-modal__input",
    changeHandler: changeHandler
  })), /*#__PURE__*/React.createElement(Col, {
    style: {
      padding: "0px"
    },
    className: "cb-location-modal__search-button-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: changeLocationClick,
    className: "cb-location-modal__search-button",
    style: (_ref3 = {
      width: "100%"
    }, _defineProperty(_ref3, "width", "55px"), _defineProperty(_ref3, "backgroundColor", "#9d2235"), _defineProperty(_ref3, "borderRadius", "3px"), _defineProperty(_ref3, "border", "0px solid"), _defineProperty(_ref3, "marginLeft", "-10px"), _ref3)
  }, /*#__PURE__*/React.createElement(MdSearch, {
    onClick: changeLocationClick,
    disabled: isLoading,
    className: "",
    style: {
      color: "white",
      height: "3em"
    }
  }, " ")))), /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/React.createElement("label", {
    className: "cb-banner__title cb-location-modal__or-label",
    style: {
      fontFamily: "Thirsty_Script",
      color: "#653024"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "or")), useLocationButton()))));
};

function mapStateToProps(state) {
  var _state$error, _state$error2;

  return {
    isError: (_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.isError,
    err: (_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.err
  };
}

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getLocation: function getLocation(lat, lon) {
      return dispatch(locationOperations.getLocationByLatLon(lat, lon));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(formikEnhancer(ChangeLocationForm));